class ShopinfoWishlist {
    constructor() {
        this.storageKey = 'shopinfo_wishlist';
        this.handles = this.getHandles();
        this.init();
    }

    getHandles() {
        try {
            const stored = localStorage.getItem(this.storageKey);
            return stored ? JSON.parse(stored) : [];
        } catch (e) {
            console.error('Wishlist: Error reading handles', e);
            return [];
        }
    }

    saveHandles() {
        localStorage.setItem(this.storageKey, JSON.stringify(this.handles));
        console.log('Wishlist: Saved handles', this.handles);
        this.broadcast();
    }

    broadcast() {
        window.dispatchEvent(new CustomEvent('wishlist:updated', {
            detail: { handles: this.handles, count: this.handles.length }
        }));
    }

    add(handle) {
        if (!handle) return;
        if (!this.contains(handle)) {
            this.handles.push(handle);
            this.saveHandles();
        }
    }

    remove(handle) {
        this.handles = this.handles.filter(h => h !== handle);
        this.saveHandles();
    }

    toggle(handle) {
        if (this.contains(handle)) {
            this.remove(handle);
        } else {
            this.add(handle);
        }
    }

    contains(handle) {
        return this.handles.includes(handle);
    }

    init() {
        document.addEventListener('click', (e) => {
            const btn = e.target.closest('.shopinfo-wishlist-btn');
            if (btn) {
                e.preventDefault();
                e.stopPropagation();
                const handle = btn.getAttribute('data-product-handle');
                this.toggle(handle);
            }
        });

        document.addEventListener('click', (e) => {
            const btn = e.target.closest('.shopinfo-share-btn');
            if (!btn) return;

            e.preventDefault();
            e.stopPropagation();
            this.shareProduct(btn);
        });

        // Ensure buttons sync state when data changes
        window.addEventListener('wishlist:updated', () => this.updateButtons());

        // Initialize UI
        const events = ['DOMContentLoaded', 'pageshow', 'page:loaded'];
        events.forEach(evt => {
            window.addEventListener(evt, () => {
                this.handles = this.getHandles(); // Re-sync with storage
                this.broadcast();
                this.updateButtons();
            });
        });

        // Watch for newly added products (AJAX, Infinite Scroll, Wishlist page load)
        const observer = new MutationObserver((mutations) => {
            let shouldUpdate = false;
            for (const mutation of mutations) {
                if (!mutation.addedNodes) continue;
                for (let i = 0; i < mutation.addedNodes.length; i++) {
                    const node = mutation.addedNodes[i];
                    if (node.nodeType === 1) {
                        if (node.classList.contains('shopinfo-wishlist-btn') || node.querySelector('.shopinfo-wishlist-btn')) {
                            shouldUpdate = true;
                            break;
                        }
                    }
                }
                if (shouldUpdate) break;
            }
            if (shouldUpdate) this.updateButtons();
        });
        observer.observe(document.body, { childList: true, subtree: true });

        // Initial update
        setTimeout(() => {
            this.handles = this.getHandles();
            this.broadcast();
            this.updateButtons();
        }, 100);
    }

    updateButtons() {
        document.querySelectorAll('.shopinfo-wishlist-btn').forEach(btn => {
            const handle = btn.getAttribute('data-product-handle');
            if (!handle) return;
            const active = this.contains(handle);
            btn.classList.toggle('is-active', active);

            const iconColor = active ? '#e60000' : 'none';
            const strokeColor = active ? '#e60000' : 'currentColor';

            btn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="${iconColor}" stroke="${strokeColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
            </svg>`;
        });
    }

    async shareProduct(btn) {
        const shareData = {
            title: btn.getAttribute('data-share-title') || document.title,
            url: window.location.href
        };

        if (navigator.share) {
            try {
                await navigator.share(shareData);
                return;
            } catch (e) {
                if (e.name === 'AbortError') return;
            }
        }

        this.copyShareUrl(btn, shareData.url);
    }

    async copyShareUrl(btn, url) {
        if (!navigator.clipboard || !window.isSecureContext) return;

        try {
            await navigator.clipboard.writeText(url);
            btn.dataset.shareState = 'copied';
            setTimeout(() => {
                delete btn.dataset.shareState;
            }, 1800);
        } catch (e) {
            console.warn('Wishlist: Could not copy product URL', e);
        }
    }
}

// Global API instance Singleton
if (!window.ShopinfoWishlistAPI) {
    window.ShopinfoWishlistAPI = new ShopinfoWishlist();
}

class WishlistCounter extends HTMLElement {
    constructor() {
        super();
        this._update = (e) => this.render(e?.detail?.count);
    }

    connectedCallback() {
        window.addEventListener('wishlist:updated', this._update);
        // Initial setup
        this.render();
    }

    disconnectedCallback() {
        window.removeEventListener('wishlist:updated', this._update);
    }

    render(forcedCount) {
        const api = window.ShopinfoWishlistAPI;
        if (!api) return;

        let count = forcedCount !== undefined ? forcedCount : (api.handles ? api.handles.length : 0);

        // Final safety check against 0-count errors
        if (count === 0 && api.getHandles) {
            const freshHandles = api.getHandles();
            if (freshHandles.length > 0) count = freshHandles.length;
        }

        console.log('WishlistCounter: Rendering count', count);

        let textEl = this.querySelector('.cart-bubble__text-count');
        if (!textEl) {
            this.innerHTML = `<span class="cart-bubble__background"></span><span class="cart-bubble__text"><span class="cart-bubble__text-count"></span></span>`;
            textEl = this.querySelector('.cart-bubble__text-count');
        }

        if (textEl) textEl.textContent = count;

        // Visibility handling
        if (count > 0) {
            this.classList.add('is-visible');
            this.style.setProperty('display', 'flex', 'important');
        } else {
            this.classList.remove('is-visible');
            this.style.removeProperty('display');
        }
    }
}

if (!customElements.get('wishlist-counter')) {
    customElements.define('wishlist-counter', WishlistCounter);
}
